import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="py-14 pb-7 border-t border-border">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr] gap-12 mb-9">
          <div>
            <div className="flex items-center gap-2.5 mb-2">
              <div className="w-8 h-8 bg-[#EF4444] rounded-lg flex items-center justify-center text-white font-bold text-lg">
                a
              </div>
              <span className="font-bold text-xl tracking-tight text-foreground">
                Apprendo
              </span>
            </div>
            <p className="text-[14px] text-muted-foreground mt-2 max-w-[260px]">
              Your team&apos;s conversations are your best content. AI finds the moments that matter.
            </p>
          </div>
          <div>
            <h4 className="text-[12px] font-bold uppercase tracking-[1px] text-foreground mb-3.5">Product</h4>
            <ul className="space-y-2">
              <li><Link href="#pricing" className="text-[14px] text-muted-foreground hover:text-foreground transition-colors">Pricing</Link></li>
              <li><Link href="/for-creators" className="text-[14px] text-muted-foreground hover:text-foreground transition-colors">For Creators</Link></li>
              <li><Link href="/for-teams" className="text-[14px] text-muted-foreground hover:text-foreground transition-colors">For Teams</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-[12px] font-bold uppercase tracking-[1px] text-foreground mb-3.5">Resources</h4>
            <ul className="space-y-2">
              <li><Link href="/home/guides" className="text-[14px] text-muted-foreground hover:text-foreground transition-colors">Browse Guides</Link></li>
              <li><Link href="/security" className="text-[14px] text-muted-foreground hover:text-foreground transition-colors">Security</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-[12px] font-bold uppercase tracking-[1px] text-foreground mb-3.5">Company</h4>
            <ul className="space-y-2">
              <li><Link href="/about" className="text-[14px] text-muted-foreground hover:text-foreground transition-colors">About</Link></li>
              <li><Link href="/careers" className="text-[14px] text-muted-foreground hover:text-foreground transition-colors">Careers</Link></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-5 border-t border-border text-[13px] text-muted-foreground">
          <span>&copy; {new Date().getFullYear()} Apprendo Inc. All rights reserved.</span>
          <div className="flex flex-wrap gap-5 mt-3 md:mt-0">
            <Link href="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link href="/terms" className="hover:text-foreground transition-colors">Terms of Service</Link>
            <Link href="/security" className="hover:text-foreground transition-colors">Security</Link>
            <Link href="/ai-transparency" className="hover:text-foreground transition-colors">AI Transparency</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
